// "Lead generated by: Agent | Team" (contacts and pipeline records -> carried onto the deal's leadSource).
// Default: 'agent' when an agent enters their own lead; 'team' when it is assigned to them by someone else
// or imported. Only admins can change it afterwards (app + database rules).
const LEAD_GENERATED_BY = ['agent', 'team'];
function leadGeneratedByDefault({ creatorUid, ownerUid, imported } = {}) {
  if (imported) return 'team';
  return creatorUid && ownerUid && creatorUid !== ownerUid ? 'team' : 'agent';
}
// Deal leadSource value the forms use.
const dealLeadSourceFor = (leadGeneratedBy) => (leadGeneratedBy === 'team' ? 'team-generated' : leadGeneratedBy === 'agent' ? 'agent-generated' : '');
module.exports = { LEAD_GENERATED_BY, leadGeneratedByDefault, dealLeadSourceFor };
